import React,{useEffect,useState} from "react";
import {useForm} from "react-hook-form";
import {useAtom} from "jotai";
import {useLocation,useNavigate} from "react-router-dom";
import styled from "styled-components";
import {updateNoticeAdmin} from "../../services/notice/NoticeAdminAxios";
import {tokenResultAtom} from "../login/entity";
import PlatformSectionHeader from "../platform_manage/PlatformSectionHeader";
import {
  ActionGuide,
  ButtonGroup as ActionButtons,
  DetailBody,
  DetailFieldGroup as FieldGroup,
  DetailFieldLabel as FieldLabel,
  DetailForm,
  FieldDescription,
  PrimaryButton as Submit,
  RequiredMark as Required,
  SecondaryButton as Cancel,
  StickyActionBar as Actions,
  SurfaceCard as DetailCard
} from "../../components/common/PageStyles";

export default function NoticeDetail(){
  const [token]=useAtom(tokenResultAtom);
  const {state}=useLocation();
  const navigate=useNavigate();
  const {handleSubmit}=useForm();
  const [notice,setNotice]=useState({title:"",content:"",publishYn:"N"});
  const isAdmin=token.role!=="NORMAL";
  useEffect(()=>{if(state?.data)setNotice(state.data);},[state?.data]);
  const submit=()=>isAdmin&&updateNoticeAdmin(notice).then(()=>navigate("/board/notice",{replace:true}));
  const publishAction=isAdmin?<PublishHeaderAction>
    <span>게시 여부</span>
    <PublishToggle>
      <PublishOption $active={notice.publishYn==="Y"}><input type="radio" checked={notice.publishYn==="Y"} onChange={()=>setNotice(prev=>({...prev,publishYn:"Y"}))}/><Dot/>게시</PublishOption>
      <PublishOption $active={notice.publishYn==="N"} $inactive><input type="radio" checked={notice.publishYn==="N"} onChange={()=>setNotice(prev=>({...prev,publishYn:"N"}))}/><Dot/>미게시</PublishOption>
    </PublishToggle>
  </PublishHeaderAction>:null;
  return <DetailForm onSubmit={handleSubmit(submit)}>
    <DetailCard>
      <PlatformSectionHeader title="공지사항 상세" description="공지사항 제목과 내용을 확인하고 필요한 정보를 수정합니다." action={publishAction}/>
      <DetailBody>
        <FieldGroup><FieldLabel>공지사항 제목 {isAdmin&&<Required>*</Required>}</FieldLabel><FieldDescription>공지사항 목록과 상세 화면에 표시되는 제목입니다.</FieldDescription>
          <TitleInput value={notice.title||""} readOnly={!isAdmin} onChange={e=>setNotice(prev=>({...prev,title:e.target.value}))}/></FieldGroup>
        <FieldGroup><FieldLabel>공지사항 내용 {isAdmin&&<Required>*</Required>}</FieldLabel><FieldDescription>사용자에게 안내할 공지사항의 전체 내용을 입력합니다.</FieldDescription>
          <ContentArea value={notice.content||""} readOnly={!isAdmin} onChange={e=>setNotice(prev=>({...prev,content:e.target.value}))}/></FieldGroup>
      </DetailBody>
    </DetailCard>
    <Actions><ActionGuide><strong>공지사항 정보 설정</strong><span>변경한 내용을 확인한 뒤 수정하거나 목록으로 이동할 수 있습니다.</span></ActionGuide>
      <ActionButtons><Cancel type="button" onClick={()=>navigate("/board/notice")}>목록</Cancel>{isAdmin&&<Submit type="submit">수정</Submit>}</ActionButtons>
    </Actions>
  </DetailForm>;
}
const fieldCss=`width:100%;box-sizing:border-box;border:1px solid #dfe3e7;border-radius:8px;background:#fff;color:#333;font-size:11px;outline:0;&:hover:not(:read-only){border-color:var(--theme-primary-border);}&:focus:not(:read-only){border-color:var(--theme-primary);box-shadow:0 0 0 3px var(--theme-primary-focus-ring);}&:read-only{background:#f5f6f7;cursor:default;}`;
const TitleInput=styled.input`${fieldCss}height:42px;padding:0 12px;`;
const ContentArea=styled.textarea`${fieldCss}min-height:260px;max-height:560px;padding:18px;resize:vertical;line-height:1.75;white-space:pre-wrap;`;
const PublishToggle=styled.div`display:inline-flex;gap:6px;padding:4px;border:1px solid #e1e5e8;border-radius:9px;background:#f5f6f7;`;
const PublishHeaderAction=styled.div`
  display:flex;align-items:center;gap:10px;
  > span{color:#68737e;font-size:10px;font-weight:700;white-space:nowrap;}
  @media(max-width:640px){width:100%;justify-content:space-between;}
`;
const PublishOption=styled.label`position:relative;display:inline-flex;min-width:86px;height:30px;align-items:center;justify-content:center;gap:7px;padding:0 12px;border:1px solid ${({$active,$inactive})=>$active?($inactive?"#f2c2c2":"#b7e4cf"):"transparent"};border-radius:6px;background:${({$active,$inactive})=>$active?($inactive?"#fff1f1":"#ecf8f2"):"transparent"};color:${({$active,$inactive})=>$active?($inactive?"#d14343":"#16845b"):"#7b8289"};font-size:10px;font-weight:700;cursor:pointer;input{position:absolute;width:1px;height:1px;opacity:0;}`;
const Dot=styled.span`width:6px;height:6px;border-radius:50%;background:currentColor;`;
